import { TMasterStandardIndustryGroup } from "@/api/entities/master-standard-industry-group.entity";
import { useUpdateStandardIndustryGroup } from "@/api/services/global/master";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenGroupModalProps = {
  hiddenGroup?: TMasterStandardIndustryGroup;
  setHiddenGroup: Dispatch<SetStateAction<TMasterStandardIndustryGroup | undefined>>;
};

export const HiddenGroupModal: FC<THiddenGroupModalProps> = ({ hiddenGroup, setHiddenGroup }) => {
  const updateMutation = useUpdateStandardIndustryGroup();

  const handleSubmit = async () => {
    if (!hiddenGroup) return;
    try {
      await updateMutation.mutateAsync({ id: toNumber(hiddenGroup.id), payload: { isHidden: !hiddenGroup.isHidden } });
      toast.success(API_SUCCESS_MESSAGE);
      setHiddenGroup(undefined);
    } catch (error) {
      setHiddenGroup(undefined);
      showError(error);
    }
  };

  return (
    <Modal
      title={hiddenGroup?.isHidden ? "有効化の確認" : "無効化の確認"}
      isOpen={Boolean(hiddenGroup)}
      onClose={() => setHiddenGroup(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      isLoadingOkBtn={updateMutation.isPending}
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenGroup?.isHidden ? "この行が有効化されますが、よろしいですか。" : "この項目が無効化されますが、よろしいですか。"}
      </Typography>
    </Modal>
  );
};
